import { useEffect, useState } from "react";
import "./useAnimation.css";

type Direction = "up" | "down" | "left" | "right";

interface UseAnimationOptions {
  direction?: Direction;
  duration?: number; // in ms
  delay?: number;    // in ms
}

export function useAnimation({
  direction = "up",
  duration = 500,
  delay = 0,
}: UseAnimationOptions = {}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return {
    className: `slide-fade ${direction} ${show ? "show" : ""}`,
    style: { transitionDuration: `${duration}ms` },
    show,
  };
}